import { useEffect, useState } from 'react';
import { isEmpty } from '../utils/utils';
import { genericHandlerError } from './commonServices';
import { toast } from '../app/toaster/toast';
import { axiosInstance } from '../utils/axiosInstance';

function usePost<T>(initValue: {
  url: string;
  defaultValue: any;
  queryParams?: any;
  transformData?: Function;
  method?: string;
  fileToSend?: string;
  successMessage?: string;
  onFailure?: Function;
  prefixFileName?: boolean;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [result, setResult] = useState(initValue.defaultValue);

  useEffect(() => {
    if (initValue.onFailure) {
      initValue.onFailure();
    }
    genericHandlerError(error);
  }, [error]);

  useEffect(() => {
    if (!isEmpty(result)) {
      initValue.successMessage || toast.success('Operation completed successfully!.');
    }
  }, [result]);

  const makeRequest = async (data: any, newUrl: string) => {
    try {
      setIsLoading(true);
      const url = newUrl || initValue.url;
      const dataToSend = initValue.transformData ? initValue.transformData(data) : data;
      const requestConfig: any = {
        method: initValue.method || 'POST',
        url,
        data: dataToSend
      };

      if (!!initValue.fileToSend) {
        var formData = new FormData();

        Object.keys(dataToSend).map(key => {
          if (key === initValue.fileToSend) {
            if (initValue.prefixFileName) {
              dataToSend[key].forEach((dropped: any) => formData.append(key + dropped.file.name, dropped.file));
            } else {
              dataToSend[key].forEach((dropped: any) => formData.append(key, dropped.file));
            }
          } else {
            formData.append(key, dataToSend[key]);
          }
        });

        requestConfig.data = formData;
        requestConfig['headers'] = {
          'Content-Type': 'multipart/form-data'
        };
      }

      const preResult = await axiosInstance(requestConfig);
      setResult(preResult);
    } catch (error: any) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return [result, makeRequest, isLoading, error];
}

export default usePost;
